export const DOWNLOAD_REPORT_TYPES = "transaction-item-discount";

export const REPORT_UPDATED_EVENT = "report-updated";
